import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var PluginKeymap = /*#__PURE__*/function () {
  function PluginKeymap() {
    _classCallCheck(this, PluginKeymap);
    _defineProperty(this, "keymap", {});
  }
  _createClass(PluginKeymap, [{
    key: "bindKey",
    value: function bindKey(key, handler) {
      this.keymap = _objectSpread(_objectSpread({}, this.keymap), {}, _defineProperty({}, key, handler));
    }
  }, {
    key: "bindMultipleKeys",
    value: function bindMultipleKeys(keys, handler) {
      var _this = this;
      keys.forEach(function (key) {
        _this.keymap = _objectSpread(_objectSpread({}, _this.keymap), {}, _defineProperty({}, key, handler));
      });
    }
  }, {
    key: "unbindKey",
    value: function unbindKey(key) {
      var _this$keymap = this.keymap,
        keyToUnbind = _this$keymap[key],
        rest = _objectWithoutProperties(_this$keymap, [key].map(_toPropertyKey));
      this.keymap = rest;
    }
  }, {
    key: "getKeyBinding",
    value: function getKeyBinding(key) {
      return this.keymap[key];
    }
  }]);
  return PluginKeymap;
}();